<template>

<div class="col-12">
    <loading-div v-if='!isReady'></loading-div>

    <!-- Tags -->
    <div v-if='isReady && phases.length' class="row mb-4">
        <div class="col-12">
            
            <ul class="list-unstyled w-100 list-pills justify-content-center d-flex flex-column flex-md-row">
                
                <li v-for='(p,i) in phases' 
                    @click='phase = p.id' 
                    :class="['ml-1 mr-1 mb-2 md-md-0', { active : phase == p.id }]">
                    <span>{{ p.name }}</span>
                </li>

            </ul>

        </div>
    </div>

    <!--Listing -->
    <div v-if='isReady && projects.length' class="row">

        <div v-for='p in projects' v-show='p.phase_id == phase' class="col-lg-4 col-md-6 mb-4 mb-md-5">
            <div class="list-item list-contractors shadow-lg h-100 project-item d-flex flex-column justify-content-between">
                <div class="list-content">
                    <a class="lp-box-link" :href="url('projects/' + p.slug)">
                        <img class="img-responsive" 
                              :src="p.image ? p.image : '/resources/images/def-img.jpg'" 
                              :alt="p.name">

                        <span class="overlay d-flex align-items-center justify-content-center">
                            <span class="overlay-inner text-center">
                                <span class="icon icon-chevrons-right"></span>
                                <span class="text mt-3">Виж още</span>
                            </span>
                        </span>
                    </a>

                    <div class="list-info pt-3 pb-4 pl-4 pr-4 text-center">
                        <span class="badge badge-secondary badge-stage mb-2">
                            Участие в: {{ p.phase }}
                        </span>
                        <h5>
                            <a href="#">
                                {{ p.name }}
                            </a>
                        </h5>
                    </div>
                </div>

                    <div class="list-bottom">
                        <ul class="list-unstyled list-inline">
                            <li class="list-inline-item">
                                <span class="icon icon-flag"></span>
                                {{ p.city }}
                            </li>
                            <li class="list-inline-item">
                                <span class="icon icon-folder"></span>
                                {{ p.type }}
                            </li>
                        </ul>
                    </div>              
 
            </div>
        </div>

    </div>

    <div class="row d-flex justify-content-center" v-if='isReady && !projects.length'>
        <div class="col-10 alert alert-info">
            Този изпълнител все още не е участвал в проекти.
        </div>
    </div>


</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        created() {
           
        },

        props : ['uid'],

        data() {
            return {
                isReady : false,
                projects : [],
                phase : false,
                phases : [],
            }
        },

        methods : {

            getData() {
                var me = this;

                me.ajax.call('cnt:gtp', { u : this.uid }, (r) => {
                    
                    if( r.status == 'success' ) {

                        me.projects = r.data;


                        if( me.projects.length ) {
                            var phases = {};

                            for( var i in me.projects ) {
                                phases[ me.projects[i].phase_id ] = me.projects[i].phase;
                            }
                            
                            for( var i in phases ) {
                                me.phases.push({ id : i, name : phases[i] });
                            }

                            me.phase = me.phases[0].id;
                        }

                        me.isReady = true;
                    }

                })
            },
        }

    }
</script>
